import enLocale from 'date-fns/locale/en-US';
import esLocale from 'date-fns/locale/es';

export const localeMap = [
  { localeName: 'en', localeProvider: enLocale },
  { localeName: 'es', localeProvider: esLocale },
];
